(function($) {
    $(document).ready(function() {
        const searchBoxIdFields = $('[data-sf-role="searchTextBoxId"]');

        for (let i = 0; i < searchBoxIdFields.length; i++) {
            const searchBoxIdField = $(searchBoxIdFields[i]);
            const controlServerData = {
                resultsUrl: searchBoxIdField.siblings('[data-sf-role="resultsUrl"]').first().val(),
                indexCatalogue: searchBoxIdField.siblings('[data-sf-role="indexCatalogue"]').first().val(),
                disableSuggestions: $.parseJSON(searchBoxIdField.siblings('[data-sf-role="disableSuggestions"]').first()
                    .val()),
                minSuggestionLength: searchBoxIdField.siblings('[data-sf-role="minSuggestionLength"]').first().val(),
                suggestionFields: searchBoxIdField.siblings('[data-sf-role="suggestionFields"]').first().val(),
                language: searchBoxIdField.siblings('[data-sf-role="language"]').first().val(),
                suggestionsRoute: searchBoxIdField.siblings('[data-sf-role="suggestionsRoute"]').first().val(),
                searchTextBoxSelector: searchBoxIdField.val(),
                searchButtonSelector: searchBoxIdField.siblings('[data-sf-role="searchButtonId"]').first().val()
            };
            featherSearchBoxWidget(controlServerData);
        }

        function featherSearchBoxWidget(serverData) {
            var searchTextBox = $(serverData.searchTextBoxSelector);
            const searchButton = $(serverData.searchButtonSelector);

            searchButton.click(navigateToResults);
            searchTextBox.keydown(keydownHandler);

            if (!serverData.disableSuggestions) {
                searchTextBox.keyup(keyupHandler);
                searchTextBox.blur(focusLost);
            }

            function keydownHandler(e) {
                const upArrowKeyCode = 38;
                const downArrowKeyCode = 40;
                const escKeyCode = 27;
                const enterKeyCode = 13;

                if (!e)
                    e = window.event;

                var keyCode = null;
                if (e.keyCode) {
                    keyCode = e.keyCode;
                } else {
                    keyCode = e.charCode;
                }

                switch (keyCode) {
                case downArrowKeyCode:
                    navigateUsingDownArrowKey(e.target);
                    break;
                case upArrowKeyCode:
                    navigateUsingUpArrowKey(e.target);
                    break;
                case escKeyCode:
                    $(e.target.parentElement.querySelector("div.search-suggestions")).hide();
                    break;
                case enterKeyCode:
                    navigateToResults(e);
                    break;
                default:
                    break;
                }
            }

            function navigateUsingDownArrowKey(targetInput) {
                const suggestionsList = targetInput.parentElement.querySelector("ul.suggestions-list");
                const selectedItem = suggestionsList.querySelector("li.active");
                const allListItems = suggestionsList.querySelectorAll("li");

                if (selectedItem === null && allListItems.length > 0) {
                    const firstListItem = suggestionsList.firstChild;
                    firstListItem.classList.add("active");
                    targetInput.value = firstListItem.innerText;
                } else if (selectedItem !== suggestionsList.lastChild) {
                    selectedItem.classList.remove("active");
                    selectedItem.nextSibling.classList.add("active");
                    targetInput.value = selectedItem.nextSibling.innerText;
                }
            }

            function navigateUsingUpArrowKey(targetInput) {
                const suggestionsList = targetInput.parentElement.querySelector("ul.suggestions-list");
                const selectedItem = suggestionsList.querySelector("li.active");

                if (selectedItem !== null && selectedItem !== suggestionsList.firstChild) {
                    selectedItem.classList.remove("active");
                    selectedItem.previousSibling.classList.add("active");
                    targetInput.value = selectedItem.previousSibling.innerText;
                }
            }

            function suggestionsSuccessHandler(result, args) {
                const dataSource = result.Suggestions;
                if (dataSource !== null && dataSource.length > 0) {
                    activateSuggestions(dataSource);
                } else {
                    deactivateSuggestions(dataSource);
                }
            }

            function activateSuggestions(dataSource) {
                const suggestions = searchTextBox.siblings(".search-suggestions");

                const list = $("<ul />", { class: "suggestions-list list-group" });
                for (let i = 0; i < dataSource.length; i++) {
                    if (dataSource[i].length > 0) {
                        list.append($("<li />",
                            {
                                class: "list-group-item",
                                text: dataSource[i],
                                mousedown: itemMousedown
                            }));
                    }
                }

                suggestions.html(list);
                suggestions.removeClass("hidden").show();
            }

            function deactivateSuggestions(dataSource) {
                const suggestions = searchTextBox.siblings(".search-suggestions");
                suggestions.addClass("hidden").show();
            }

            function focusLost(e) {
                $(e.target.parentElement.querySelector("div.search-suggestions")).hide();
            }

            function keyupHandler(e) {
                const upArrowKeyCode = 38;
                const downArrowKeyCode = 40;
                const escKeyCode = 27;

                if (e.keyCode !== upArrowKeyCode && e.keyCode !== downArrowKeyCode && e.keyCode !== escKeyCode) {
                    const enterKeyCode = 13;
                    if (e.keyCode === enterKeyCode) {
                        navigateToResults(e);
                    }

                    const searchText = searchTextBox.val().trim();
                    if (searchText.length >= serverData.minSuggestionLength) {
                        const request = {};
                        request.IndexName = serverData.indexCatalogue;
                        request.SuggestionFields = serverData.suggestionFields;
                        request.Text = searchText;
                        request.Language = serverData.language;

                        $.ajax({
                            type: "GET",
                            url: serverData.suggestionsRoute,
                            dataType: "json",
                            data: request,
                            success: suggestionsSuccessHandler
                        });
                    }
                }
            }

            function navigateToResults(e) {
                if (!e)
                    e = window.event;

                if (e.stopPropagation) {
                    e.stopPropagation();
                } else {
                    e.cancelBubble = true;
                }
                if (e.preventDefault) {
                    e.preventDefault();
                } else {
                    e.returnValue = false;
                }

                const query = searchTextBox.val();

                if (query && query.trim() && serverData.indexCatalogue) {
                    sendSentence();
                    window.location = getLocation();
                }
            }

            function getLocation() {
                const query = searchTextBox.val().trim();

                const separator = (serverData.resultsUrl.indexOf("?") === -1) ? "?" : "&";

                const catalogueParam = separator + "indexCatalogue=" + encodeURIComponent(serverData.indexCatalogue);
                const searchQueryParam = "&searchQuery=" + encodeURIComponent(query);

                const url = serverData.resultsUrl + catalogueParam + searchQueryParam;

                return url;
            }

            function sendSentence() {
                if (window.DataIntelligenceSubmitScript) {
                    DataIntelligenceSubmitScript._client.sentenceClient.writeSentence({
                        predicate: "Search for",
                        object: searchTextBox.val(),
                        objectMetadata: [
                            {
                                'K': "PageUrl",
                                'V': location.href
                            }
                        ]
                    });
                }
            }

            function itemMousedown(e) {
                searchTextBox.val(e.target.textContent);
                navigateToResults(e);
            }
        }
    });
}(jQuery));